import s from './muslim-berries.module.css';

function MuslimBerries() {
    return (
        <div className={s.muslimBerries}>Berries gathering rate is increased</div>
    );
}

export default MuslimBerries;
